// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-west-1",
    "stage": "staging",
    "accountName": "now",
    "api_url": "https://6h66f6nyo0.execute-api.eu-west-1.amazonaws.com/staging/graphql",
    "notifications_api_url": "https://6h66f6nyo0.execute-api.eu-west-1.amazonaws.com/staging/notifications",
    "run_daily_test_url": "https://5u5321nwl0.execute-api.eu-west-1.amazonaws.com/staging/run-daily-test",
    "sport_highlights_url": "https://mgrsb6wtjnhf5ou6xqnqpqkl6m.appsync-api.eu-west-1.amazonaws.com/graphql",
    "appconfig_url": "https://6h66f6nyo0.execute-api.eu-west-1.amazonaws.com/staging/getConfig",
    "direct_appconfig_url": "https://5qy0v1zzzi.execute-api.eu-west-1.amazonaws.com/staging",
		"endpoint_url" : "https://6h66f6nyo0.execute-api.eu-west-1.amazonaws.com/staging",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_nZbfweyax",
    "aws_user_pools_web_client_id": "61idhkbfk91dtemneul566dnth",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-nowstaging.auth.eu-west-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.staging.now.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.staging.now.aidisco.sky.com",
        "responseType": "code"
    },
    "defaultChannelName": "ExternalSLE",
    "playfactoryLicenseAcquisitionEndpointUrl": "https://0brbxd7y3a.execute-api.eu-west-1.amazonaws.com/staging",
    "arcusLicenseAcquisitionEndpointUrl": "https://3y7fbum86e.execute-api.eu-west-1.amazonaws.com/staging",
    "viperProxyUrl": ""
};

export default awsConfig;

